/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {
  useMemo,
  useEffect,
  useRef
} from "react";
import objectPath from "object-path";
import ApexCharts from "apexcharts";
import {
  Dropdown
} from "react-bootstrap";
import {
  useHtmlClassService
} from "../../../layout";
import {
  DropdownMenu4,
  DropdownCustomToggler
} from "../../dropdowns";
import {
  KTUtil
} from "../../../_assets/js/components/util";
import {
  gql,
  useQuery
} from '@apollo/client';
import {
  Spinner
} from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

export function MixedWidget({
  className,
  title,
  subtitle,
  tooltip,
  query,
  whitelist,
  client,
  type
}) {

  const data = query;

  const uiService = useHtmlClassService();
  const chartEl = useRef(null);
  const layoutProps = useMemo(() => {
    return {
      colorsGrayGray100: objectPath.get(uiService.config, "js.colors.gray.gray100"),
      colorsGrayGray700: objectPath.get(uiService.config, "js.colors.gray.gray700"),
      colorsThemeBaseSuccess: objectPath.get(
        uiService.config,
        "js.colors.theme.base.success"
      ),
      colorsThemeLightSuccess: objectPath.get(
        uiService.config,
        "js.colors.theme.light.success"
      ),
      fontFamily: objectPath.get(uiService.config, "js.fontFamily")
    };
  }, [uiService]);

  useEffect(() => {
    const element = chartEl.current;
    if (!element || !query) {
      return;
    }

    if (!query) return null;
    
    let percentage = 0;
    if (type === "total") {
      percentage = parseFloat((100 * (query.total_links_removed / (query.total_links_removed + query.total_pending)))) || 0;
    } else {
      percentage = parseFloat(100 - (100 * (data.action.aggregate.count + data.check.aggregate.count) / (data.action.aggregate.count + data.check.aggregate.count + data.pending.aggregate.count + data.removed.aggregate.count))) || 0;
    }

    const height = parseInt(KTUtil.css(element, 'height'));
    const options = getChartOptions(layoutProps, height, parseFloat(percentage.toFixed(0)));

    const chart = new ApexCharts(element, options);
    chart.render();
    return function cleanUp() {
      chart.destroy();
    };
  }, [layoutProps, query]);

  if (!query) {
    return (
      <>
        <div className={`card card-custom ${className}`}>
          <div className="card-header border-0">
          </div>
          <div className="card-body pt-0">
            <div className="d-flex align-items-center flex-wrap mb-5">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div style={{ marginBottom: "10px" }}>
      <div className={`card card-dashboard ${className}`} style={{ height: "350px" }}>
        {/* Header */}
        <div className="card-header border-0" style={{ display: "block", marginTop: "18px" }}>
          <OverlayTrigger
            key="bottom"
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-bottom`}>
                {tooltip}
              </Tooltip>
            }
          ><>
              <h3 style={{ cursor: "pointer" }} className="font-weight-bolder text-dark">{title}</h3>
            </>
          </OverlayTrigger>
          <p style={{ cursor: "pointer" }} className="text-dark-25">{tooltip}</p>
        </div>
        {/* Body */}
        <div className="card-body d-flex justify-content-center" style={{ padding: "0" }}>
          <div className="row">
            <div className="col-12" style={{marginTop: "-20px"}}>
              <div
                ref={chartEl}
                style={{
                  height: "140px",
                }}
              >

              </div>

            </div>
            <div className="col-12" style={{ display: "flex", marginTop: "-20px", justifyContent: "center", flexDirection: "column" }}>
              {(type === "total" && query) ?
                <>
                  <div className="row" style={{paddingLeft: "40px", paddingRight: "40px"}}>
                  <div className="col-6">Open links: {query.open_links.toLocaleString('de-DE')}</div>
                  <div className="col-6">Removed links: {query.total_links_removed.toLocaleString('de-DE')}</div>
                  </div>
                </>
                :
                <>
                  <div>Action: {data.action ? data.action.aggregate.count.toLocaleString('de-DE') : 0}</div>
                  <div>Check: {data.check ? data.check.aggregate.count.toLocaleString('de-DE') : 0}</div>
                </>
              }
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}



function getChartOptions(layoutProps, height, percentage) {
  const options = {
    series: [percentage],
    chart: {
      height: 240,
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: "55%"
        },
        dataLabels: {
          showOn: "always",
          name: {
            show: false,
            fontWeight: "700",
          },
          value: {
            color: layoutProps.colorsGrayGray700,
            fontSize: "20px",
            fontWeight: "700",
            offsetY: 8,
            show: true
          },
        },
        track: {
          background: layoutProps.colorsThemeLightSuccess,
          strokeWidth: '100%'
        }
      }
    },
    colors: [layoutProps.colorsThemeBaseSuccess],
    stroke: {
      lineCap: "round",
    },
    labels: ["Progress"]
  };
  return options;
}
